import { useEffect } from "react";
import { useTranslation } from 'react-i18next';

// onResponse types : sent, invalid, auth-screen, error, success, fail
const SumUp = ({ bookingCheckoutId, email, handlePayment, setModalStep }) => {
  const { i18n } = useTranslation();
  const lang = i18n.language || "es";
  useEffect(() => {
    if (window.SumUpCard) {
      window.SumUpCard.mount({
        id: "sumup-card",
        checkoutId: bookingCheckoutId,
        country: "ES",
        email: email,
        locale: lang === "es"? "es-ES": lang === "fr"? "fr-FR": "en-GB",
        onResponse: (type, body) => {
          if (process.env.REACT_APP_PAYMENTS_ENABLED === 'true') {
            if (type === "success") {
              handlePayment(body);
            // TODO: confirm flow for invalid and fail
            // } else if (type === "error" || type === "invalid " || type === "fail ") {
            } else if (type === "error") {
              setModalStep("error");
            }
          } else {
            if (type === "sent") {
              handlePayment(body);
            }
          }
        },
      });
    }
  }, []);

  return <div id="sumup-card"></div>;
};

export default SumUp;